function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useContext, memo, useRef, useState, useEffect } from 'react';
import { Row, Col, DropdownMenu, UncontrolledDropdown, DropdownToggle, ListGroup } from 'reactstrap';
import { _translate, WeverCoreContext } from "../../../../services/core";
import Icon from "../../../common/icon";
import MenuCategory from "./menu-category";
import useMode from "./use-utils";
var Modes = function Modes(_ref) {
  var onChange = _ref.onChange;
  var _useContext = useContext(WeverCoreContext),
    locale = _useContext.locale;
  var _useMode = useMode(),
    categories = _useMode.categories,
    defaultMode = _useMode.defaultMode;
  var dropdownRef = useRef();
  var _useState = useState(),
    _useState2 = _slicedToArray(_useState, 2),
    mode = _useState2[0],
    setMode = _useState2[1];
  var closeDropDown = function closeDropDown() {
    dropdownRef.current.state.isOpen = false;
  };
  var handleModeChange = function handleModeChange(valueResponse) {
    setMode(valueResponse);
    onChange('mode', valueResponse.alias);
    closeDropDown();
  };
  useEffect(function () {
    if (!defaultMode) return;
    setMode(defaultMode);
  }, [defaultMode]);
  if (!categories) {
    return null;
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(UncontrolledDropdown, {
    className: "dropdown-sequence-2",
    direction: "down",
    ref: dropdownRef
  }, /*#__PURE__*/React.createElement(DropdownToggle, {
    variant: "success",
    className: "select-dropdown rounded-pill ".concat((mode === null || mode === void 0 ? void 0 : mode.name) && 'selected', " ")
  }, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    className: "col-auto d-flex justify-content-start align-items-center px-0"
  }, /*#__PURE__*/React.createElement("span", {
    className: "label"
  }, mode !== null && mode !== void 0 && mode.name ? _translate(mode.name[locale]) : _translate('collectorapp_select_mode'))), /*#__PURE__*/React.createElement(Col, {
    className: "d-flex justify-content-end align-items-center"
  }, /*#__PURE__*/React.createElement(Icon, {
    className: "icon-categorized type-1 ml-2",
    name: !(mode !== null && mode !== void 0 && mode.name) ? 'chevron-down' : 'times'
  })))), /*#__PURE__*/React.createElement(DropdownMenu, {
    direction: "down",
    className: "py-0 menu"
  }, /*#__PURE__*/React.createElement("div", {
    className: "background",
    role: "button",
    onClick: function onClick() {
      return closeDropDown();
    }
  }), /*#__PURE__*/React.createElement(ListGroup, {
    className: "menu-list"
  }, categories.map(function (category) {
    if (!category) {
      return null;
    }
    return /*#__PURE__*/React.createElement(MenuCategory, {
      key: "".concat(category.id, "_").concat(category.alias, "_").concat(parseInt(Math.random() * 10000)),
      category: category,
      bottom: true,
      onChange: handleModeChange
    });
  })))));
};
export default /*#__PURE__*/memo(Modes);